<template>
  <div class="container py-5 ms-page">

    <!-- Title -->
    <h2 class="page-title mb-4">MS Office Package</h2>

    <!-- Description -->
    <p class="lead">
      Microsoft Office is a powerful suite of productivity applications used in 
      education, business, administration, and daily computer work.
    </p>

    <!-- Section 1 -->
    <div class="card-section mt-4">
      <h4 class="section-title">📘 What is MS Office?</h4>
      <p>
        MS Office is a collection of essential desktop applications developed 
        by Microsoft to perform tasks such as word processing, data calculation, 
        presentations, and communication.
      </p>
    </div>

    <!-- Section 2 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🧩 Main Applications</h4>
      <ul>
        <li><strong>Microsoft Word:</strong> Create and edit documents.</li>
        <li><strong>Microsoft Excel:</strong> Perform calculations, data analysis, and charts.</li>
        <li><strong>Microsoft PowerPoint:</strong> Create presentations with slides.</li>
        <li><strong>Microsoft Access:</strong> Manage and organize databases.</li>
        <li><strong>Microsoft Outlook:</strong> Email, calendar, and communication tools.</li>
      </ul>
    </div>

    <!-- Section 3 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🎯 Why Use MS Office?</h4>
      <ul>
        <li>Easy to use for beginners.</li>
        <li>Powerful tools for school, office, and business.</li>
        <li>Worldwide standard software.</li>
        <li>Compatible with many file formats.</li>
        <li>Helps improve productivity and efficiency.</li>
      </ul>
    </div>

    <!-- Section 4 -->
    <div class="card-section mt-4">
      <h4 class="section-title">📌 Real-World Uses</h4>
      <ul>
        <li>Creating documents (letters, CVs, reports).</li>
        <li>Managing budgets and sales data.</li>
        <li>Presenting lessons and business ideas.</li>
        <li>Database management in companies.</li>
        <li>Email communication and scheduling.</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "MSOffice",
};
</script>

<style scoped>
.page-title {
  font-weight: 800;
  color: #2563eb;
}

.lead {
  color: #374151;
  font-size: 1.1rem;
}

.card-section {
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #2563eb;
}

.section-title {
  color: #1e40af;
  font-weight: 600;
}
</style>
